import { post,put,get } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const getPayFacCommissionsByPricingTableGuid = payFacPricingTableDefGuid => get(url.GET_PAYFAC_COMMISSIONS_BY_PRICING_TABLE_GUID+"?payFacPricingTableDefGuid="+ payFacPricingTableDefGuid)
export const getPayFacCommissionsByPricingTableGuidAndMerchantGuid = (record) => post(url.GET_PAYFAC_COMMISSIONS_BY_PRICING_TABLE_GUID, record);
export const insertMerchantcommissions = (record) => post(url.INSERT_MERCHANT_COMMISSIONS, record);
export const updateMerchantcommissions = (record) => put(url.UPDATE_MERCHANT_COMMISSIONS, record);
